import { Box, styled } from "@mui/material";

const CenterBox = styled(Box)({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
});

export default CenterBox;
